import {
  Box,
  Button,
  Container,
  FormControl,
  Input,
  Typography,
} from 'components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useResetPasswordMutation } from 'services/authCompany';
import RouteName from 'config/routes';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Breadcrumb } from 'apps/company/components';
import yup from 'shared/yubGlobal';
import useTitle from 'hooks/useTitle';

function ResetPassword(props) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  useTitle(t('common:pageTitle:resetPassword'));
  const schema = yup.object().shape({
    password: yup
      .string()
      .required(t('validate:requiredPassword'))
      .password(t('validate:invalidPassword')),
    password_confirmation: yup
      .string()
      .required(t('validate:requiredPassword'))
      .oneOf([yup.ref('password')], t('resetPassword:invalidConfirmPassword')),
  });
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(schema),
  });

  const watchPassword = watch('password', '');
  const watchConfirmPassword = watch('password_confirmation', '');

  const [resetPassword, { isLoading }] = useResetPasswordMutation();

  function handleResetPassword(data) {
    const payload = {
      params: {
        reset_password_token: searchParams.get('reset_password_token'),
      },
      body: data,
    };
    resetPassword(payload)
      .unwrap()
      .then(() => {
        navigate(RouteName.loginCompany, { replace: true });
      })
      .catch(() => {})
      .finally();
  }

  return (
    <Container>
      <Breadcrumb content={t('resetPassword:title')}></Breadcrumb>
      <form>
        <Box pb={16}>
          <Typography variant="description">
            {t('resetPassword:newPassword')}
          </Typography>
        </Box>
        <FormControl error={errors.password}>
          <Input
            type="password"
            placeholder={t('resetPassword:inputPassword')}
            {...register('password')}
          ></Input>
        </FormControl>
        <Box pb={16}>
          <Typography variant="description">
            {t('resetPassword:confirmPassword')}
          </Typography>
        </Box>
        <FormControl error={errors.password_confirmation}>
          <Input
            type="password"
            placeholder={t('resetPassword:inputConfirmPassword')}
            {...register('password_confirmation')}
          ></Input>
        </FormControl>
      </form>
      <Box pt={42}>
        <Button
          variant="contained"
          disabled={!watchPassword || !watchConfirmPassword || isLoading}
          onClick={handleSubmit(handleResetPassword)}
        >
          {t('resetPassword:textBtnSubmit')}
        </Button>
      </Box>
    </Container>
  );
}

export default ResetPassword;
